import React, {PropsWithChildren} from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement>, PropsWithChildren {}


const SubTitle = ({ ...props}:Props) => {
    return (
        <h2 className={`text-gray-600 uppercase font-medium`}>
            {props.children}
        </h2>
    );
};

export default SubTitle;
